export const brokerDealerBiddingActions = {
    BROKER_DEALER_BIDDING_RESET: 'BROKER_DEALER_BIDDING_RESET',
    BROKER_DEALER_ACCESS_STATE: 'BROKER_DEALER_ACCESS_STATE',
    BROKER_DEALER_BIDDING_STORE_SECURITIES: 'BROKER_DEALER_BIDDING_STORE_SECURITIES',
}
